import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import FilterBar from './filter/filter-bar'
import SearchBar from './filter/search-bar'
import filters from './filter/filter-options.json'
import FilterTags from './filter/filter-tags'

const ProjectsTabStyled = styled.div`
  .filter-bar {
    margin-block-start: 40px;
    display: flex;
    overflow: visible;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
  }
  .tab-options {
    display: flex;
  }
`

const ProjectTabStyled = styled.li`
  font: var(--regularBold);
  font-size: 14px;
  line-height: 24px;
  padding: 8px 6px;
  cursor: pointer;
  color: ${({ value, filterValue }) => (value === filterValue ? 'var(--baseNeutral)' : 'var(--neutral40)')};
  border-bottom: 4px solid;
  border-bottom-color: ${({ value, filterValue }) => (value === filterValue ? 'var(--secondary)' : 'transparent')};
  &:hover{
    color: var(--baseNeutral);
  }
  @media(min-width: 768px) {
    font-size: 16px;
  }
`

const options = [
  {
    filterValue: '',
    text: 'Todos',
    type: '',
  },
  {
    filterValue: 'new',
    text: 'Nuevos',
    type: 'filter',
  },
]

function ProjectsFilter() {
  const [value, setValue] = useState('')
  const router = useRouter()
  const { search, filter } = router.query
  useEffect(() => {
    if (search) {
      setValue(search)
    }
    if (filter) {
      setValue(filter)
    }
  }, [])
  const handleChange = (selected, type) => {
    setValue(selected)
    const queryParam = type === 'filter' ? { filter: selected } : { search: selected }
    const query = selected === '' ? {} : queryParam
    router.push({
      pathname: '/proyectos/todos',
      query,
      shallow: true,
    })
  }
  return (
    <>
      <ProjectsTabStyled>
        <SearchBar />
        <div className="filter-bar">
          <ul className="tab-options">
            {options.map(({ text, filterValue, type }) => (
              <ProjectTabStyled key={filterValue} filterValue={filterValue} value={value} role="button" onClick={() => handleChange(filterValue, type)}>
                {text}
              </ProjectTabStyled>
            ))}
          </ul>
          <FilterBar filters={filters} />
        </div>
      </ProjectsTabStyled>
      <FilterTags filters={filters} />
    </>
  )
}

export default ProjectsFilter
